// components/overlay/Overlay.tsx

import React from 'react';
import { OverlayProps } from './types';
import { BaseImage } from '@/components/baseImage/BaseImage'; // If needed
import SerializeDescription from '../serialize-description/SerializeDescription';
import { Divider } from '../divider/Divider';
import { Headline } from '../headline/Headline';
import { Button } from '../button/Button';
import Icon from '@/components/icon/Icon';
import { useTranslations } from '@/lib';

export const Overlay: React.FC<OverlayProps> = ({
  isOpen,
  onClose,
  image,
  name,
  position,
  positionEn,
  background,
  backgroundEn,
  email,
  linkedIn,
}) => {
  const { locale, t } = useTranslations();
  const displayPosition = locale === 'en' ? positionEn : position;
  const displayBackground = locale === 'en' ? backgroundEn : background;

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="relative h-fit w-full max-w-[560px] rounded-lg bg-white p-4 shadow-xl sm:p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          onClick={onClose}
          className="absolute right-3 top-3 text-gray-500 hover:text-black"
          variant="tertiary"
          rightIcon={{ name: 'x', size: '24px' }}
        />

        <div className="flex flex-row gap-3">
          <div className="team-image">
            {image && (
              <BaseImage
                {...image}
                className="h-16 w-16 rounded-full"
                classNameImage="w-16 h-16 rounded-full"
                alt={name}
              />
            )}
          </div>
          <div className="name-position">
            <h2 className="text-lg font-medium text-brand-700">{name}</h2>
            {position && (
              <p className="text-xs text-neutral-700">{displayPosition}</p>
            )}
          </div>

          {/* You can optionally render background blocks here */}
        </div>

        <Divider
          className="border-neutral-50"
          size="small"
          border={true}
          width="full"
        />

        <div className="background flex flex-col gap-1">
          {displayBackground && (
            <Headline
              level="h3"
              variant="baseTextM"
              title={t('overlay.background')}
              className="overlay-heading !m-0 uppercase"
            />
          )}
          {displayBackground && (
            <SerializeDescription
              description={displayBackground}
              className="overlay-description !text-xl !font-normal !text-neutral-700"
            />
          )}
        </div>
        {linkedIn && (
          <div className="kontakt flex flex-col gap-1 pt-5">
            <Headline
              level="h3"
              variant="headingThree"
              title={t('overlay.contact')}
              className="!m-0 !text-xs !font-medium uppercase !text-neutral-700"
            />
            <div className="flex flex-row gap-2">
              <a
                href={`${linkedIn}`}
                className="!p-0"
                target="_blank"
                aria-label="linkedin link"
              >
                <Icon name={'linkedin'} color={' #272835'} size={'24px'} />
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
